import { v4 as uuidv4 } from 'uuid';

import { Login } from '../../../../vtex-apps/login/Login/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { FlexLayoutRow, FlexLayoutCol } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { SearchBar } from '../../../../vtex-apps/store-components/SearchBar/default';
import { Logo } from '../../../../vtex-apps/store-components/Logo/default';
import { StickyLayout } from '../../../../vtex-apps/sticky-layout/StickyLayout/default';
import { OverlayTrigger } from '../../../../vtex-apps/overlay-layout/overlayTriggerDefault';
import { OverlayLayout } from '../../../../vtex-apps/overlay-layout/overlayLayoutDefault';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
import { DisclosureTrigger } from '../../../../vtex-apps/disclosure-layout/DisclosureTrigger/default';
import { DisclosureLayout } from '../../../../vtex-apps/disclosure-layout/DisclosureLayout/default';
import { DisclosureContent } from '../../../../vtex-apps/disclosure-layout/DisclosureContent/default';

const HeaderDesktop = () => {
	return {
		componentName: 'HeaderDesktop',
		componentId: uuidv4(),
		componentGroup: 'HeaderDesktop',
		variables,
		props: {
			mzTitle: 'MZ | Header - Desktop',
			blockClass: 'header-desk-3',
		},
		childrenComponents: [
			VisibilityLayout({ mzTitle: 'MZ | Tipbar Top Header (On/Off)', visible: true }, [
				FlexLayoutRow({ blockClass: 'header-desk-3-top', horizontalAlign: 'between', colSizing: 'auto' }, [
					FlexLayoutCol({ blockClass: 'header-desk-3__flex-col-top' }, [
						RichText({
							text: 'Há 26 anos oferecendo materiais médico-hospitalares de qualidade em todo Brasil',
							blockClass: 'header-desk-3__top-text',
						}),
						OverlayTrigger({ blockClass: 'overlay-trigger__header-desk-3' }, [
							RichText({
								blockClass: 'header-desk-3__overlay-rich-text',
								text: 'Central de Atendimento',
							}),
							OverlayLayout({ blockClass: 'overlay-layout__header-desk-3' }, [
								FlexLayoutRow({ blockClass: 'overlayout-item-row__header-desk-3', colSizing: 'auto' }, [
									RichText({
										blockClass: 'overlay-item__header-desk-3',
										text: '[Fale com a gente pelo WhatsApp]()',
									}),
									RichText({
										blockClass: 'overlay-item__header-desk-3',
										text: '[Envie seu contato para a gente]()',
									}),
									RichText({
										blockClass: 'overlay-item__header-desk-3',
										text: 'Atendimento: de Segunda a Sexta-feira das 09:00 as 18:00 e Sábado das 08:00 as 13:00',
									}),
								]),
							]),
						]),
					]),
				]),
			]),
			StickyLayout({ blockClass: 'header-desktop-3-sticky', position: 'top', verticalSpacing: 0 }, [
				FlexLayoutRow(
					{
						colSizing: 'auto',
						fullWidth: false,
						horizontalAlign: 'between',
						blockClass: 'header-desk-3__main-row',
					},
					[
						FlexLayoutCol({ blockClass: 'header-desktop-3__col-logo', width: { desktop: 'grow', mobile: 'grow' } }, [
							Logo({
								width: 300,
								url: 'https://maeztra.com/wp-content/uploads/2020/09/logo_Prancheta-1.svg',
								href: '/',
								title: 'Logo',
								blockClass: 'header-desk-3__logo',
							}),
						]),
						FlexLayoutCol({ blockClass: 'header-desk-3__col-menu' }, [
							{
								componentGroup: 'StoreMenuDesktop',
								componentName: 'FlexLayoutRow',
								componentId: uuidv4(),
							},
						]),
						FlexLayoutCol({ width: { desktop: 'grow', mobile: 'grow' } }, [
							FlexLayoutRow({ colSizing: 'auto', colGap: { desktop: 3 }, blockClass: 'header-desk-3__row-icons' }, [
								DisclosureLayout({}, [
									DisclosureTrigger(
										{
											blockClass: 'header-desk-3__search-disclosure-trigger',
										},
										[
											RichText({
												text: 'A [nome loja]',
												blockClass: 'footer-mobile-1-title',
												textAlignment: 'left',
												textPosition: 'left',
											}),
										],
									),
									DisclosureContent({ blockClass: 'header-desk-3__search-disclosure-content' }, [
										FlexLayoutRow({ blockClass: 'header-desk-3__row-search' }, [
											SearchBar({
												placeholder: 'O que você procura?',
												inputType: 'text',
												maxWidth: '517px',
												blockClass: 'header-desk-3__search-bar',
											}),
										]),
									]),
								]),

								Login({ iconLabel: 'Minha Conta', blockClass: 'header-desk-3__login' }),
								RichText({
									text: '[Favoritos](/wishlist)',
									blockClass: 'header-desk-3__favorites',
								}),
								{
									componentGroup: 'MinicartGroup',
									componentName: 'MinicartGroup',
									componentId: uuidv4(),
								},
							]),
						]),
					],
				),
			]),

			// VisibilityLayout({visible:true,mzTitle:"MZ | Modal de cookies (On/Off)"},[{componentName:"CookieModal"}]),
			VisibilityLayout({ colSizing: 'auto', mzTitle: 'MZ | Botão Whatsapp (On/Off)' }, [
				FlexLayoutRow({ blockClass: 'header-desk-3-whats-float__flex-row' }, [
					Image({ blockClass: 'whatsapp-float-3__image' }),
					RichText({ blockClass: 'whatsapp-float-3__text', text: '[Atendimento](https://whts.co/)' }),
				]),
			]),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--top-header-desk-3-text-color', name: 'Top Header Text' },
			{ from: '--white', to: '--top-header-desk-3-link-color', name: 'Top Header Link' },
			{ from: '--brand-color-primary-pure', to: '--top-header-desk-3-bg-color', name: 'Top Header Background' },
			{ from: '--cta-color-pure', to: '--top-header-desk-3--link-bg-color', name: 'Top Header Link Background' },
			{ from: '--white', to: '--header-desk-3-bg-color', name: 'Header Background' },
			// { from: "--white", to: "--header-desktop-3-menu-bg-color", name: "Menu Background", },
			{ from: '--text-color-3-dark', to: '--header-desk-3-text-color', name: 'Icons Text' },
			// { from: "--text-color-3-dark", to: "--header-desktop-3-menu-text-color", name: "Menu Text", },
			//search bg color
			{ from: '--white', to: '--header-desk-3-search-bg-color', name: 'Search Row Background' },
			//search Input bg
			{ from: '--white', to: '--header-desk-3-search-input-bg-color', name: 'Search Input Background' },
			{ from: '--text-color-1-dark', to: '--header-desk-3-search-border-color', name: 'Search Border' },
			{ from: '--text-color-1', to: '--header-desk-3-search-icon-color', name: 'Search Icon' },
			//search text color
			{ from: '--text-color-1', to: '--header-desk-3-search-text-color', name: 'Search Text' },

			{
				from: '--text-color-1-dark',
				to: '--header-desk-3-categories-border-color',
				name: 'All Categories Border',
			},
			{ from: '--text-color-1', to: '--header-desk-3-cda-text', name: 'Central de Atendimento Text' },
			{ from: '--support-color-3', to: '--header-desk-3-minicart-color', name: 'Minicart' },
			{ from: '--white', to: '--header-desk-3-minicart-text', name: 'Minicart Text' },
			{ from: '--support-color-3', to: '--header-desk-3-whatsapp-bg-color', name: 'Whatsapp Background' },
			{ from: '--support-color-3', to: '--header-desk-3-whatsapp-bg-hover', name: 'Whatsapp Background Hover' },
		],
	},
	{
		type: 'borderWidth',
		list: [{ from: '--border-width-hairline', to: '--header-desk-3-search-bw', name: 'Search Width' }],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-none', to: '--header-desk-3-border-radius', name: 'Border Radius' },
			// { from: "--border-radius-sm", to: "--header-desktop-3-submenu-br", name: "Submenu", },
			//login border radius
			{ from: '--border-radius-sm', to: '--header-desk-3-login-br', name: 'Login' },
			//whatsapp border radius
			{ from: '--border-radius-sm', to: '--header-desk-3-whatsapp-br', name: 'Whatsapp' },
			//search border radius
			{ from: '--border-radius-sm', to: '--header-desk-3-search-br', name: 'Search' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-sm', to: '--top-header-desk-3-text-size', name: 'Top Header Text Size' },
			{ from: '--font-size-sm', to: '--top-header-desk-3-link-size', name: 'Top Header Link Size' },
			{ from: '--font-size-xs', to: '--header-desk-3-main-size', name: 'Icons Size' },
			{ from: '--font-size-xs', to: '--header-desk-3-cda-text-fs', name: 'Central de Atendimento' },
			//search text size
			{ from: '--font-size-xs', to: '--header-desk-3-search-fs', name: 'Search' },
			//submenu text size
			// { from: "--font-size-xs", to: "--header-desktop-3-submenu-fs", name: "Submenu", },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--header-desk-3-fw', name: 'Main font weight' },
			//search
			{ from: '--font-weight-400', to: '--header-desk-3-search-fw', name: 'Search font weight' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-nano', to: '--header-desk-3-topbar-spacing', name: 'Topbar size' },
			{ from: '--spacing-atom', to: '--header-desk-3-submenu-gap', name: 'Submenu Items Gap' },
			//submenu lateral padding
			{ from: '--spacing-sm', to: '--header-desk-3-submenu-lateral-padding', name: 'Submenu Lateral Padding' },
		],
	},
];

export default HeaderDesktop;
